import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';

import { Select } from '../../../../forms/select';
import { industryOptions } from '../../../../helpers/industries';
import industryMessages from '../../../../helpers/industries.messages';
import messages from '../CompanyDetails.messages';

const IndustryQuestion = (props) => {
    const { onChange } = props;

    return (
        <Select
            className={classNames('IndustryQuestion', 'fs-exclude')}
            label={<FormattedMessage {...messages.industry} />}
            name="industry"
            onChange={onChange}
            selectOptions={{
                options: industryOptions
            }}
            messages={industryMessages}
        />
    );
};

// eslint-disable-next-line import/no-default-export
export default IndustryQuestion;
